import LoginButton from '../shared/components/auth/LoginButton';

import { Box, Typography, Paper } from '@mui/material';
import styles from './login.module.css';
import { Link } from '@airbus/components-react'; // assuming these exist
import { useLanguageContextAPI } from '../shared/context/LanguageContext';
import { useConfigContext } from '../shared/context/ConfigContext';
import { useSearchParams } from 'react-router';

export default function LoginPage() {
  const { t } = useLanguageContextAPI();
  const [searchParams] = useSearchParams();
  const { appName } = useConfigContext();
  const [firstName, secondName, ...restName] = (appName || t('app_name')).split(' ');

  const message = searchParams.get('message');
  return (
    <div className={styles.container}>
      <Typography variant='h4' style={{ fontWeight: 600 }}>
        {firstName} {secondName} <span style={{ fontWeight: 300 }}>{restName.join(' ')}</span>
      </Typography>

      {message && (
        <Typography variant='h6' style={{ fontWeight: 300 }}>
          {message}
        </Typography>
      )}

      <Paper className={styles.paper}>
        <Typography variant='h6' gutterBottom>
          {t('login.login')}
        </Typography>
        <Typography variant='body2' paragraph>
          {t('login.enterprise')}
        </Typography>
        <LoginButton>{t('login.sign_in_onelogin')}</LoginButton>
      </Paper>
      <Box className={styles.links}>
        <Link href='https://sites.google.com/airbus.com/mbdcp/support' target='_blank'>
          {t('support')}
        </Link>
      </Box>
    </div>
  );
}
